import { Validator, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { HisUiService } from '../service/base/his-ui.service';

/**
 * Wrapper für einen Validator bzw. Validator-Function, um bei Fehlschlag den ValidationState
 * mit einer internationailsierbaren Meldung anzureichen.
 * Dabei können die Fehlerinformationen des gewrappeten Validators als Parameter eingesetzt werden.
 *
 * TODO: wie kann ich hier statisch auf den HisUiService zugreifen?
 */
export class HisValidatorAndMessage implements Validator {
    messageKey: string;
    paramNames: string[];
    dirtyOnly = true;

    /**
     * Konstruktor
     *
     * @param name Schlüssel, unter dem die Validator-Funktion ihre Fehlerinformationen im ErrorState ablegt
     * @param validatorFn Validator-Funktion
     * @param hisUiService HisUiService
     */
    constructor( public name: string, private validatorFn: ValidatorFn, private hisUiService: HisUiService ) {}

    /**
     * Wiederverwendbare Methode zum erzeugen der Fehlermeldung aus errorState und Konfiguration
     */
    public static createErrorMessage( stateObject: any, messageKey: string, paramNames: string[], hisUiService: HisUiService ): string {
        let params: any[] = [];
        if ( paramNames ) {
            paramNames.forEach( name => {
                params.push( stateObject[name] );
            } );
        }

        return hisUiService.translate( messageKey, ...params );
    }

    getValidatorFn(): ValidatorFn {
        return this.validatorFn;
    }

    /**
     * Führt die Validierung aus und reichert im Fehlerfall den State mit einer Message an
     */
    validate( c: AbstractControl ): ValidationErrors {
        if ( this.dirtyOnly && !c.dirty ) {
            return null;
        }

        let state = this.validatorFn( c );
        if ( state ) {
            state = this.fillValidationState( state );
        }
        return state;
    }

    /**
     * Reichert den ValidationState mit einer ggf. parametrierten I18n-Message an.
     */
    fillValidationState( state: ValidationErrors ): ValidationErrors {
        state = this.normalizeState( state );
        let stateObject = state[this.name];
        if ( stateObject ) {
            stateObject.valid = false;
            stateObject.message = HisValidatorAndMessage.createErrorMessage( stateObject, this.messageKey,
                this.paramNames, this.hisUiService );
        }

        return state;
    }

    /**
     * Einige Validatoren weichen von der Systematik ab, ein Error-Objekt mit 'valid=false'
     * anzulegen. Für diese wird der state so umgeformt, dass er darauf passt.
     * Das dient insb. dazu, später die Message dem Error-Objekt hinzufügen zu können.
     */
    normalizeState( state: ValidationErrors ): ValidationErrors {
        if ( state.required === true ) {
            state.required = {};
        }

        return state;
    }
}
